module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "pg16"
    }
  }, [_vm._v("3")])]), _c('a', {
    attrs: {
      "id": "pg16"
    }
  }, [_c('p', {
    staticClass: "chaptit"
  }, [_vm._v("Steamer "), _c('i', [_vm._v("Pulaski")]), _vm._v(" Explosion, 1838")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On Thursday June 14, 1838, the steam packet "), _c('i', [_vm._v("Pulaski")]), _vm._v(" left Charleston, South Carolina, headed for Baltimore, Maryland. The "), _c('i', [_vm._v("Pulaski")]), _vm._v(" was manned with 37 crew members and carrying 160 passengers, of which 50 were ladies. The "), _c('i', [_vm._v("Pulaski")]), _vm._v(" was under the command of Captain Dubois.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About thirty miles off the coast of North Carolina, traveling in moderate weather on a dark starry night, no one realized that disaster was just minutes away. About 11:00 p.m., the starboard boiler exploded. First Mate Hibberd was in charge of the boat at the time of the unexpected explosion. He had taken command at 10:00 p.m. After the explosion, the dazed Hibberd managed to pull himself together and make it to the site of the boiler explosion. The boat’s midships was blown to pieces, and the "), _c('i', [_vm._v("Pulaski")]), _vm._v(" was taking on water each time it rolled in that direction. Hibberd began letting the passengers know that the boat was sinking. The yawls were lowered, but some sank because of long exposure to the sun. Forty-five minutes after the boiler explosion, the "), _c('i', [_vm._v("Pulaski")]), _vm._v(" went to the bottom. The passengers in the remaining lifeboats could see the hopeless people holding onto whatever was available and floating in all directions. The two yawls and fourteen people survived under the direction of First Mate Hibberd.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b343324","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter03.vue
// module id = 81
// module chunks = 0